import React from 'react';

import { ComboBoxOption } from '../constants';
import { buildClassNamesForTextDisplay } from './helpers';
import { TestID } from './constants';

export interface Props {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  selectableOption: ComboBoxOption;
  stackSubText?: boolean;
}

const SearchResultsListItem: React.FC<Props> = ({
  onClick,
  selectableOption,
  stackSubText = false,
}) => {
  const { displayTextClassName, subTextClassName, textWrapperClassName } =
    buildClassNamesForTextDisplay({ stackSubText });

  const { displayText, key, subText } = selectableOption;

  return (
    <li>
      <button
        data-testid={TestID}
        className="font-medium text-gray-800 w-full hover:rounded-md hover:bg-gray-100 p-1 py-2"
        onClick={onClick}
        value={key}
      >
        <div className={textWrapperClassName}>
          <div className={displayTextClassName}>{displayText}</div>

          {subText && <div className={subTextClassName}>{subText}</div>}
        </div>
      </button>
    </li>
  );
};

export default SearchResultsListItem;
